module.exports = __webpack_public_path__ + "static/media/register.a4b5719b.svg";